import { render, staticRenderFns } from "./DigitalMembership.vue?vue&type=template&id=620028bd&scoped=true"
import script from "./DigitalMembership.vue?vue&type=script&lang=js"
export * from "./DigitalMembership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620028bd",
  null
  
)

export default component.exports